<div appModal #modal="modal">
    <div class="modal-dialog modal-dialog-centered" role="document">

        <div class="modal-content pb-5">
        <div class="modal-header justify-content-end">
            <p class="modal-clost-btn" data-bs-dismiss="modal" aria-label="Close">&times;</p>
        </div>
          <div class="modal-body text-center" >
            <div>
                <img width="100px" src="/assets/resource/success-mark.png" alt="img">
            </div>
            <div>
                <h5 class="title mt-3 text-pry">That’s all !</h5>
                <p class="desc">Your room has been added to the property, </p>
                <div class="mt-4"> 
                    <app-button data-bs-dismiss="modal" lg primary>Continue</app-button>
                    <a data-bs-dismiss="modal" (click)="addAnotherRoom()"  class="ms-3">Add another room</a>
                </div>
            </div>
          </div>
        </div>
      </div>
</div> 